import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
    const servicesData = [
      {
        id: 1,
        title: 'Tournaments',
        batch: '01',
        description: 'Current tournament schedule.',
        imgOne: 'assets/img/icon/tour-11.png',
        imgTwo: 'assets/img/icon/tour-1.png',
        href: '/tournaments',
      },
      {
        id: 2,
        title: 'News',
        batch: '02',
        description: 'Latest news in the PUBGM community.',
        imgOne: 'assets/img/icon/news-22.png',
        imgTwo: 'assets/img/icon/news-2.png',
        href: '/news',
      },
      {
        id: 3,
        title: 'Ratings',
        batch: '03',
        description: 'Ratings of players of different levels.',
        imgOne: 'assets/img/icon/rating-33.png',
        imgTwo: 'assets/img/icon/rating-3.png',
        href: '/prorating',
      },
    ];
    return (
        <div className="services__area section-padding" style={{backgroundImage: `url('assets/img/services.png')`}}>
            <div className="container">
                <div className="row mb-30">
                    <div className="col-xl-12">
                        <div className="services__area-title lg-t-center"> 
                            <span className="subtitle one">services</span>
                            <h2>Here you will find</h2> 
                        </div>
                    </div>
                </div>
                <div className="row">
                    {servicesData.map((item, id)=>(
                        <div className="col-xl-6 col-lg-6 col-md-6" key={id}>
                            <div className="services__area-item"> 
                                <span>{item.batch}</span>
                                <div className="services__area-item-icon">
                                    <img src={item.imgTwo} alt="" />
                                    <div className="services__area-item-icon-one">
                                        <img src={item.imgOne} alt="" />
                                    </div>
                                </div>
                                <div className="services__area-item-content">
                                    <h4><Link to={item.href}>{item.title}</Link></h4>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Services;